<template lang="pug">
  div.wrap-module-slide
    ItemToolHeader(ref="toolHeader"
      :slide="slide" :currentTool="currentTool"
      @setCurrentTool="setCurrentTool"
      @setFontOption="setFontOption")
    div.slide-content
      div(v-if="showingPage").wrap-slide.f.fh
        div(ref="slideImg"
          @click="onSlideImg"
          :class="{'cursor-is-plus': cursorIsPlus}").wrap-slide-img.mt6
          img(ref="slideImg" :src="showingPage.imgURL")
          ItemToolPreviewText(v-if="showingPreview == 'text' && slide"
            @resetTool="resetTool"
            :showingPage="showingPage" :posForPreview="posForPreview"
            :fontOption="fontOption"
            :slide="slide" :doodles="doodles")
          ItemToolPreviewImage(v-if="showingPreview == 'image' && slide"
            ref="toolPreviewImage"
            @resetTool="resetTool"
            :showingPage="showingPage" :posForPreview="posForPreview"
            :slide="slide" :doodles="doodles")
          div(:class="{'prevent-click' : cursorIsPlus}").wrap-doodles
            div(v-for="item in doodles").wrap-doodle
              ItemDoodleText(v-if="item.type =='text' && item.page == showingPage.id"
                v-show="showDoodle"
                :key="item.id" :doodle="item" :hostUid="slide.createdBy"
                @playDoodleSound="playDoodleSound")
              ItemDoodleImage(v-if="item.type =='image' && item.page == showingPage.id"
                v-show="showDoodle"
                :key="item.id" :doodle="item"
                @playDoodleSound="playDoodleSound")
          div(v-if="this.uid === slide.createdBy").wrap-page-controller.f.flex-between.mb12
            v-icon(@click.stop="goPreviousPage"
              size="32px" color="#999").cursor-pointer.mr4 mdi-chevron-left-circle
            v-icon(@click.stop="goNextPage"
              size="32px" color="#999").cursor-pointer mdi-chevron-right-circle
          transition(v-for="(user, index) in users"
            name="usertransition")
            ItemSlideUser(:key="user.id" :user="user"
              v-if="$refs.slideImg && user.id != uid && (index < showingUserNum || latestReactingUsers.includes(user.id)) || (slide.createdBy == user.id && user.id != uid)"
              v-show="showUsers"
              :slide="slide"
              :messages="messages"
              :parentSlideElem="$refs.slideImg"
              @playEmortSound="playEmortSound" @playMsgPopSound="playMsgPopSound")
          transition(name="usertransition")
            ItemSlideUserMe(:user="me"
              v-if="$refs.slideImg"
              :slide="slide"
              :messages="messages"
              :parentSlideElem="$refs.slideImg"
              @playEmortSound="playEmortSound" @playMsgPopSound="playMsgPopSound")
          div.wrap-toggle-object.f.fm
            v-icon(size="22px"
              @click="showDoodle = !showDoodle").mr8 {{(showDoodle) ? 'mdi-eye' : 'mdi-eye-off'}}
            v-icon(size="22px"
              @click="showUsers = !showUsers").mr8 {{(showUsers) ? 'mdi-account' : 'mdi-account-off'}}
            //- div.wrap-slider
              v-slider(v-model="showingUserNum" :max="showingUserMaxNum" min="1"
                color="white" step="1")
          div.wrap-showing-user-num-controller.f
            //- v-icon mdi-account-group
            v-slider(v-if="showingUserNum"
              v-model="showingUserNum"
              :max="showingUserMaxNum" min="1"
              :color="pallete.$active_color" step="1" height="100%"
              append-icon="mdi-account-group" :icon-color="pallete.$active_color"
              vertical thumb-label="always")
              //- :label="`${showingUserNum}/${showingUserMaxNum}`" inverse-label)
              template(v-slot:thumb-label="item").f.fh
                span(:style="`font-size: ${showingUserMaxNum > 99 ? 10 : 12}px;`") {{`${showingUserNum}/${showingUserMaxNum}`}}
            
            //- span.block {{`${showingUserNum}/${showingUserMaxNum}`}}
    div.wrap-input.f.fc
      div.input-content
        div.f.fc.mb8
          ItemInputSound(ref="inputSound" :me="me" :loadedSoundsNum="loadedEmortSoundsNum"
            @playAllSoundsForPermission="playAllSoundsForPermission")
        div.f.fc
          ItemInputMessage(:me="me")
    div.wrap-mindo.s-hide
      ItemSlideMindo(v-if="users && slide && doodles"
        :slide="slide" :doodles="doodles" :userNum="users.length")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

$slide_base_height: 90vh;
$sub_header_height: 32px;
.wrap-module-slide {
  padding-top: $header_height;
  .slide-content {
    position: relative;
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $slide_width_percent;
    .wrap-slide {
      width: 100%;
      height: calc(#{$slide_base_height} - #{$header_height} - #{$sub_header_height});
      overflow: visible;
      .wrap-slide-img {
        position: relative;
        &.cursor-is-plus {
          cursor: crosshair;
        }
        img {
          // object-fit: cover;
          max-width: 100%;
          max-height: 100%;
        }
        .wrap-doodles {
          &.prevent-click {
            pointer-events: none;
          }
        }
        .wrap-toggle-object {
          position: absolute;
          right: 0;
          bottom: calc(100% + 4px);
          // .wrap-slider {
          //   width: 300px;
          // }
        }
        .wrap-showing-user-num-controller {
          position: absolute;
          left: calc(100% + 16px);
          top: 0;
          height: 100%;
        }
      }
      .wrap-page-controller {
        position: absolute;
        // width: 100%;
        width: 68px;
        bottom: 0;
        left: 50%;
        margin-left: -34px;
        z-index: 1000;
      }
    }
  } // .slide-content
  .wrap-input {
    position: fixed;
    // width: 100%;
    width: 340px;
    left: calc(50% - 170px);
    bottom: 14px;
    bottom: calc(14px + constant(safe-area-inset-bottom));
    bottom: calc(14px + env(safe-area-inset-bottom));
    z-index: 1000;
    .input-content {
      width: 100%;
      // margin: 0 auto;
      // width: $base_width_percent;
      // max-width: $base_max_width_px;
    }
  }
  .wrap-mindo {
    position: fixed;
    right: 14px;
    bottom: 14px;
    bottom: calc(14px + constant(safe-area-inset-bottom));
    bottom: calc(14px + env(safe-area-inset-bottom));
  }
}

.usertransition-leave-active, .usertransition-enter-active {
  transition: all 0.4s $ease_out_elastic;
}
.usertransition-enter, .usertransition-leave-to {
  opacity: 0;
  transform: scale(0.2);
}
.usertransition-enter-to, .usertransition-leave {
  opacity: 1;
  transform: scale(1.0);
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";

.wrap-module-slide {
  .v-slider--vertical {
    height: calc(100% - 20px);
  }
  .v-input__append-outer .v-icon {
    color: $active_color;
  }
}
</style>


<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import { Howl, Howler } from 'howler'
import { emortSounds, msgPopSounds, doodleSounds } from '@/components/utils/sounds'
import ItemToolHeader from '@/components/item/ItemToolHeader'
import ItemToolPreviewText from '@/components/item/ItemToolPreviewText'
import ItemToolPreviewImage from '@/components/item/ItemToolPreviewImage2'
import ItemDoodleText from '@/components/item/ItemDoodleText'
import ItemDoodleImage from '@/components/item/ItemDoodleImage'
import ItemSlideUser from '@/components/item/ItemSlideUser'
import ItemSlideUserMe from '@/components/item/ItemSlideUserMe'
import ItemSlideMindo from '@/components/item/ItemSlideMindo'
import ItemInputSound from '@/components/item/ItemInputSound'
import ItemInputMessage from '@/components/item/ItemInputMessage'

export default {
  components: {
    ItemToolHeader,
    ItemToolPreviewText,
    ItemToolPreviewImage,
    ItemDoodleText,
    ItemDoodleImage,
    ItemSlideUser,
    ItemSlideUserMe,
    ItemSlideMindo,
    ItemInputSound,
    ItemInputMessage
  },
  props: {
    slide: {
      type: Object,
      required: true
    },
    pages: {
      type: Array,
      required: true
    },
    doodles: {
      type: Array,
      required: true
    },
    messages: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    me: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    showingUserMaxNum () {
      // return (this.users.length > this.defaultShowingUserNum) ?
      //   this.users.length : this.defaultShowingUserNum
      return this.users.length
    }
  },
  watch: {
    slide () {
      this.showingPage = this.pages
        .filter(p => p.id === this.slide.currentPage)[0]
    },
    currentTool () {
      if (this.currentTool === 'select') {
        this.cursorIsPlus = false
      } else {
        this.cursorIsPlus = true
      }
    },
    users (newUsers, oldUsers) {
      if (newUsers.length > 1 && oldUsers.length === 1) {
        let newNum = newUsers.length
        if (newNum > 50) newNum = 50
        if (newNum <= 4) newNum = 4
        this.showingUserNum = newNum
        // this.showingUserNum = newUsers.length
      }

      // 20人までの参加者は自動で全員表示にする
      if (newUsers.length < 20 && this.showingUserNum < 20) {
        this.showingUserNum = newUsers.length
      }
    },
    messages () {
      // 5秒以内にリアクションした最新30人のユーザーは表示人数上限で除外されていても表示する
      this.latestReactingUsers = this.messages
        .filter((msg, i) => i < 30)
        .filter(msg => {
          return (new Date() - msg.createdAt.toDate()) < 5000
        })
        .map(msg => msg.createdBy)
      const resetReactingUser = () => {
        this.latestReactingUsers = []
        console.log('resetReactingUser', this.latestReactingUsers)
      }
      clearTimeout(this.resetReactingUsersTimer)
      this.resetReactingUsersTimer = setTimeout(resetReactingUser, 8000)
    }
  },
  data () {
    return {
      showingPage: null,
      pageIsChanging: false,
      currentTool: 'select',
      cursorIsPlus: false,
      posForPreview: null,
      fontOption: null,
      isEditingDoodle: false,
      showingPreview: null,
      emortSounds: [],
      loadedEmortSoundsNum: 0,
      msgPopSounds: [],
      loadedMsgPopSounds: 0,
      doodleSounds: [],
      loadedDoodleSoundsNum: 0,
      showDoodle: true,
      showUsers: true,
      defaultShowingUserNum: 10,
      showingUserNum: 10,
      // showingUserMaxNum: 4,
      latestReactingUsers: [],
      resetReactingUsersTimer: null
    }
  },
  created () {
    this.showingPage = this.pages
      .filter(p => p.id === this.slide.currentPage)[0]

    if (this.uid === this.slide.createdBy) {
      document.addEventListener('keydown', this.keyDown)
    }

    this.preloadSounds()
  },
  mounted () {
    // 表示ユーザーの初期値
    this.showingUserNum = (this.users.length <= 80) ? this.users.length : 80

    // コンソールで落書きレポートを集計する用
    // window.doodles = this.doodles
    // window.messages = this.messages
    // console.log('総合落書き数：', this.doodles.length)
    // console.log('総合メッセージ数：', this.messages.length)
    // console.log('総合リアクション数：', this.doodles.length + this.messages.length)
    // console.log('総合バブル数：', this.messages.filter(e => e.type === 'normal').length)
    // console.log('総合エモート数：', this.messages.filter(e => e.type !== 'normal').length)

    // const likesSum = this.doodles.map(e => e.likeNum)
    //   .reduce((sum, element) => sum + element, 0)
    // const dislikesSum = this.doodles.map(e => e.dislikeNum)
    //   .reduce((sum, element) => sum + element, 0)
    // console.log('総合いいね！数：', likesSum)
    // console.log('総合いいね！数：', dislikesSum)
  },
  destroyed () {
    if (this.uid === this.slide.createdBy) {
      document.removeEventListener('keydown', this.keyDown)
    }
  },
  methods: {
    onSlideImg (e) {
      // e.stopPropagation()
      if (this.isEditingDoodle) {
        return
      }
      this.isEditingDoodle = true

      const rect = e.target.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top
      // console.log('Left:' + x + ' Top:' + y)

      if (this.currentTool === 'text') {
        this.posForPreview = { x: x - 172/2, y: y - 32/2 }
        this.fontOption = this.$refs.toolHeader.getFontOption()
        this.showingPreview = 'text'
      } else if (this.currentTool === 'image') {
        // this.addImg({ x, y })
        this.posForPreview = { x: x, y: y }
        this.showingPreview = 'image'
        this.$nextTick(() => {
          this.$refs.toolPreviewImage.uploadPhoto()
        })
      }
    },
    resetTool () {
      this.isEditingDoodle = false
      this.currentTool = 'select'
      this.showingPreview = null
      this.posForPreview = null
      this.fontOption = null
    },
    setFontOption () {
      this.fontOption = this.$refs.toolHeader.getFontOption()
    },
    keyDown (e) {
      if (e.code === 'ArrowLeft') {
        this.goPreviousPage()
      }
      if (e.code === 'ArrowRight') {
        this.goNextPage()
      }
    },
    async goNextPage () {
      if (this.pageIsChanging || this.showingPreview) return

      const lastPage = this.slide.pageDocs[this.slide.pageDocs.length - 1]
      if (lastPage === this.showingPage.id) return

      this.pageIsChanging = true
      const currentPageIndex = this.slide.pageDocs.map((page, index) => {
        let result = { page, index }
        if (page === this.showingPage.id) result.isCurrentPage = true
        return result
      }).filter(result => result.isCurrentPage)[0].index
      const nextPageIndex = currentPageIndex + 1
      
      await database.slideCollection().update(this.$route.params.slideId, {
        currentPage: this.slide.pageDocs[nextPageIndex]
      })
      
      this.pageIsChanging = false
    },
    async goPreviousPage () {
      if (this.pageIsChanging || this.showingPreview) return

      const firstPage = this.slide.pageDocs[0]
      if (firstPage === this.showingPage.id) return

      this.pageIsChanging = true
      const currentPageIndex = this.slide.pageDocs.map((page, index) => {
        let result = { page, index }
        if (page === this.showingPage.id) result.isCurrentPage = true
        return result
      }).filter(result => result.isCurrentPage)[0].index
      const previousPageIndex = currentPageIndex - 1
      
      await database.slideCollection().update(this.$route.params.slideId, {
        currentPage: this.slide.pageDocs[previousPageIndex]
      })

      this.pageIsChanging = false
    },
    setCurrentTool (type) {
      this.currentTool = type
    },
    // Sound系
    playEmortSound (param) {
      if (this.$refs.inputSound.isMute) return
      const targetSound = this.emortSounds
        .filter(e => e.id === param.id)[0]
      if (targetSound && targetSound.audio) {
        const vol = Number(this.$refs.inputSound.volume)
        // console.log('vol:', vol)
        targetSound.audio.volume(vol)
        // targetSound.audio.volume(param.volume)
        targetSound.audio.play('base')
      }
    },
    playMsgPopSound (param) {
      if (this.$refs.inputSound.isMute) return
      const targetSound = this.msgPopSounds
        .filter(e => e.id === param.id)[0]
      if (targetSound && targetSound.audio) {
        const vol = Number(this.$refs.inputSound.volume)
        targetSound.audio.volume(vol)
        // targetSound.audio.volume(param.volume)
        targetSound.audio.play('base')
      }
    },
    playDoodleSound (param) {
      if (this.$refs.inputSound.isMute) return
      const targetSound = this.doodleSounds
        .filter(e => e.id === param.id)[0]
      if (targetSound && targetSound.audio) {
        const vol = Number(this.$refs.inputSound.volume)
        targetSound.audio.volume(vol)
        // targetSound.audio.volume(param.volume)
        targetSound.audio.play('base')
      }
    },
    playAllSoundsForPermission () {
      console.log('playAllSoundsForPermission')
      // エモートのサウンド
      for (let i=0; i < this.emortSounds.length; i++) {
        this.emortSounds[i].audio.volume(0.0)
        this.emortSounds[i].audio.play('base')
      }
      // message pop upのサウンド
      for (let i=0; i < this.msgPopSounds.length; i++) {
        this.msgPopSounds[i].audio.volume(0.0)
        this.msgPopSounds[i].audio.play('base')
      }
    },
    preloadSounds () {
      this.emortSounds = emortSounds.map(e => {
        return { ...e, isPlaying: false }
      })
      this.msgPopSounds = msgPopSounds.map(e => {
        return { ...e, isPlaying: false }
      })
      this.doodleSounds = doodleSounds.map(e => {
        return { ...e, isPlaying: false }
      })
      // エモートのサウンド
      for (let i=0; i < this.emortSounds.length; i++) {
        this.emortSounds[i].audio = new Howl({
          src: [`/sound/${this.emortSounds[i].file}`],
          volume: 0.5,
          sprite: {
            base: [0, 2000]
          },
          onload: (e) => {
            this.loadedEmortSoundsNum++
          }
        })
      }
      // message pop upのサウンド
      for (let i=0; i < this.msgPopSounds.length; i++) {
        this.msgPopSounds[i].audio = new Howl({
          src: [`/sound/${this.msgPopSounds[i].file}`],
          volume: 0.5,
          sprite: {
            base: [0, 400]
          },
          onload: (e) => {
            this.loadedMsgPopSoundsNum++
          }
        })
      }
      // doodleのサウンド
      for (let i=0; i < this.doodleSounds.length; i++) {
        this.doodleSounds[i].audio = new Howl({
          src: [`/sound/${this.doodleSounds[i].file}`],
          volume: 0.5,
          sprite: {
            base: [0, 400]
          },
          onload: (e) => {
            this.loadedDoodleSoundsNum++
          }
        })
      }
    }
    // ------
  }
}
</script>
